export default function exhausiveCheck<T>(
  x: never,
  errorMessage = `${x} is unhandled`
): T {
  throw new Error(errorMessage);
}
